import React from 'react';

import { LoomInternalIcon as LoomBlurpleIcon } from '@atlaskit/logo/loom-internal/icon';
import { LoomInternalLogoCS as LoomBlurpleLogo } from '@atlaskit/logo/loom-internal/logo';
import { LoomIcon } from '@atlaskit/logo/loom/icon';
import { LoomLogoCS as LoomLogo } from '@atlaskit/logo/loom/logo';
import { Stack } from '@atlaskit/primitives/compiled/stack';

import LogoTable from '../utils/logo-table';

export default (): React.JSX.Element => (
	<Stack space="space.100">
		<LogoTable
			logo={[<LoomLogo appearance="brand" />, <LoomBlurpleLogo appearance="brand" />]}
			icon={[<LoomIcon appearance="brand" />, <LoomBlurpleIcon appearance="brand" />]}
		/>
	</Stack>
);
